import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Routes } from '../../config/routes';
import { ApplicationHttpClient } from '../../components/shared/http/application-http-client';
import { LegFiJwtService } from '../auth/legfi-jwt.service';
import { JwtLegFiClaims } from '../auth/jwt-legfi-claims.model';
import { Observable } from 'rxjs';
import { MessageBoardSubscription } from '../../models/entities/message-board-subscription';

/** Interface with various attributes of a subscription update/create request. */
export interface UpdateSubscriptionRequest
{
    boardId?: number;
    threadId?: number;
    membershipId?: number;
    frequency: 'instant' | 'daily' | 'weekly' | 'unsubscribe';
}

@Injectable()
export class MessageBoardSubscriptionService
{

    constructor(private _http: ApplicationHttpClient) {
    }

    /** Get message boards with a person's subscriptions called out */
    public getMemberSubscriptions(): Observable<MessageBoardSubscription[]> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url = Routes.MakeLegFiCoreUrl(Routes.LegFiCore.MessageBoardSubscriptions(jwt.orgId));

        return this._http.get(url)
                .pipe(
                        map((response: Object[]) => {
                            return response.map(board => {
                                return new MessageBoardSubscription(board);
                            });
                        }));
    }

    /** Create or update a person's board or thread subscription */
    public upsertSubscription(request: UpdateSubscriptionRequest) {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url = Routes.MakeLegFiCoreUrl(Routes.LegFiCore.MessageBoardSubscribe(jwt.orgId));

        return this._http.put(url, JSON.stringify(request));
    }

    /** Delete a person's board or thread subscription */
    public deleteSubscription(subId: number) {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url = Routes.MakeLegFiCoreUrl(Routes.LegFiCore.MessageBoardSubscription(jwt.orgId, subId));

        return this._http.delete(url);
    }

}

